<template>
  <div class="welcome-radar" aria-hidden="true">
    <div class="radar-track">
      <!-- 重复地图形成无缝横向滚动，避免欢迎区看起来像一张静态图片。 -->
      <div v-for="mapIndex in 6" :key="mapIndex" class="radar-map">
        <img class="radar-map__image" :src="worldMap" alt="" draggable="false" />
        <div class="radar-dots">
          <span
            v-for="(dot, dotIndex) in dots"
            :key="dotIndex"
            class="radar-dot"
            :class="`radar-dot--${dot.color}`"
            :style="{ left: `${dot.x}px`, top: `${dot.y}px`, animationDelay: `${(dotIndex % 2) * 1.25}s` }"
          >
            <i class="radar-dot__core"></i>
            <i class="radar-dot__ring radar-dot__ring--outer"></i>
            <i class="radar-dot__ring radar-dot__ring--inner"></i>
          </span>
        </div>
      </div>
    </div>

    <!-- 中心机器人和水波纹与地图分层，地图滚动时位置保持稳定。 -->
    <div class="welcome-radar__ripples">
      <span class="ripple ripple--outer"></span>
      <span class="ripple ripple--inner"></span>
    </div>
    <img class="welcome-radar__badge" :src="finScopeIcon" alt="ICEChat AI" />
  </div>
</template>

<script>
import worldMap from '@/images/aiChat/world-map.png';
import finScopeIcon from '@/images/aiChat/finscope-icon.gif';

export default {
  name: 'WelcomeRadar',
  data() {
    return {
      worldMap,
      finScopeIcon,
      // 点位使用示例地图的像素坐标，地图宽度固定为 340px。
      dots: [
        { x: 55, y: 55, color: 'red' },
        { x: 82, y: 66, color: 'green' },
        { x: 110, y: 78, color: 'red' },
        { x: 175, y: 49, color: 'green' },
        { x: 198, y: 65, color: 'red' },
        { x: 285, y: 70, color: 'red' },
        { x: 305, y: 95, color: 'green' },
        { x: 325, y: 55, color: 'red' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.welcome-radar {
  position: relative;
  width: 100%;
  height: 229px;
  overflow: hidden;
}

.radar-track {
  display: flex;
  width: max-content;
  height: 169px;
  animation: radar-scroll 24s linear infinite;
  will-change: transform;
}

.radar-map {
  position: relative;
  flex: 0 0 340px;
  width: 340px;
  height: 169px;
}

.radar-map__image {
  display: block;
  width: 340px;
  height: 169px;
  user-select: none;
  pointer-events: none;
}

.radar-dots {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.radar-dot {
  position: absolute;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
}

.radar-dot__core {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.radar-dot--red .radar-dot__core { background: #f24957; }
.radar-dot--green .radar-dot__core { background: #4cd47a; }

.radar-dot__ring {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 4px;
  height: 4px;
  border: 1px solid;
  border-radius: 50%;
  animation: radar-dot-pulse 2.5s ease-out infinite;
}

.radar-dot__ring--outer { border-width: 1.5px; }
.radar-dot__ring--inner { animation-delay: 1.25s; }
.radar-dot--red .radar-dot__ring { border-color: rgba(242, 73, 87, 0.75); }
.radar-dot--green .radar-dot__ring { border-color: rgba(76, 212, 122, 0.75); }

.welcome-radar__ripples {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 229px;
  pointer-events: none;
  mask-image: linear-gradient(to bottom, transparent 0, #000 60px, #000 170px, transparent 229px);
  -webkit-mask-image: linear-gradient(to bottom, transparent 0, #000 60px, #000 170px, transparent 229px);
}

.welcome-radar__badge {
  position: absolute;
  top: 139px;
  left: 50%;
  z-index: 2;
  display: block;
  width: 60px;
  height: 60px;
  transform: translateX(-50%);
}

.ripple {
  position: absolute;
  top: 169px;
  left: 50%;
  border-radius: 50%;
  transform-origin: center;
}

.ripple--outer {
  width: 60px;
  height: 60px;
  margin: -30px 0 0 -30px;
  background: radial-gradient(circle, transparent 55%, rgba(255, 255, 255, 0.95) 66%, rgba(255, 255, 255, 0.5) 75%, transparent 88%);
  animation: radar-ripple 3s ease-out infinite;
}

.ripple--inner {
  width: 40px;
  height: 40px;
  margin: -20px 0 0 -20px;
  background: radial-gradient(circle, transparent 50%, rgba(255, 255, 255, 0.9) 62%, rgba(255, 255, 255, 0.45) 72%, transparent 86%);
  animation: radar-ripple 3s ease-out 1.5s infinite;
}

@media (prefers-reduced-motion: reduce) {
  .radar-track,
  .radar-dot__ring,
  .ripple {
    animation: none;
  }
}
</style>

<style>
@keyframes radar-scroll {
  from { transform: translate3d(0, 0, 0); }
  to { transform: translate3d(-340px, 0, 0); }
}

@keyframes radar-dot-pulse {
  0% { transform: scale(1); opacity: 1; }
  70% { opacity: 0; }
  100% { transform: scale(5); opacity: 0; }
}

@keyframes radar-ripple {
  0% { transform: scale(1); opacity: 1; }
  30% { opacity: 1; }
  100% { transform: scale(10); opacity: 0; }
}
</style>
